module.exports = __webpack_public_path__ + "static/reason_lower-6d21ba9d9687793e2da0ca438d5b6813.png";